<div class="space-y-4">
  <div class="flex items-center justify-between">
    <h4 class="text-sm font-semibold text-gray-800">{{ 'DISB_NOTE.GUARANTOR_SHARE' | translate }}</h4>

    @if (!readOnly) {
    <button
      type="button"
      class="inline-flex h-9 w-9 items-center justify-center rounded-full bg-indigo-600 text-lg font-semibold text-white hover:bg-indigo-700"
      [title]="'DISB_NOTE.ADD_GUARANTOR_SHARE' | translate"
      (click)="openPopup('add')"
    >
      +
    </button>
    }
  </div>

  @if (rowsLoading) {
    <div class="text-sm text-gray-500">{{ 'DISB_NOTE.LOADING_GUARANTOR_SHARES' | translate }}</div>
  } @else if (rows.length === 0) {
    <div class="text-sm text-gray-400">{{ 'DISB_NOTE.NO_GUARANTOR_SHARES' | translate }}</div>
  } @else {
    <app-table
      [columns]="columns"
      [data]="rows"
      [actions]="tableActions"
      [enablePagination]="true"
      [pageSize]="10"
    ></app-table>
  }
</div>

@if (showPopup) {
  <app-popup
    [(show)]="showPopup"
    [title]="popupTitle"
    type="custom"
    width="w-full max-w-lg min-w-[300px]"
    [showCustomFooter]="true"
    [primaryButtonText]="popupMode === 'view' ? null : 'COMMON.SAVE'"
    [primaryButtonDisabled]="guarantorsLoading || saving"
    (primaryClick)="save()"
  >
    <form [formGroup]="form" class="space-y-4" (ngSubmit)="save()">
      <div>
        <label class="form-label mb-2 block" for="guarantorShareGrntr">
          {{ 'DISB_NOTE.GUARANTOR_NAME' | translate }} <span class="text-red-500">*</span>
        </label>

        <select id="guarantorShareGrntr" formControlName="grntrSeq" class="form-select w-full">
          <option [ngValue]="null" disabled>
            {{ (guarantorsLoading ? 'DISB_NOTE.LOADING_GUARANTORS' : 'DISB_NOTE.SELECT_GUARANTOR') | translate }}
          </option>
          @for (grntr of availableGuarantors; track grntr.grntrSeq) {
            <option [ngValue]="grntr.grntrSeq">{{ grntr.grntrNm }}</option>
          }
        </select>

        @if (popupMode === 'add' && !guarantorsLoading && availableGuarantors.length === 0) {
          <p class="mt-1 text-xs text-gray-500">{{ 'DISB_NOTE.NO_GUARANTORS_AVAILABLE' | translate }}</p>
        }

        @if (isInvalid(form.controls.grntrSeq)) {
          <p class="mt-1 text-xs text-red-600">{{ 'DISB_NOTE.ERR_GUARANTOR_REQUIRED' | translate }}</p>
        }
      </div>

      <div>
        <label class="form-label mb-2 block" for="guarantorShareValue">
          {{ 'DISB_NOTE.GUARANTOR_SHARE' | translate }} <span class="text-red-500">*</span>
        </label>

        <input
          id="guarantorShareValue"
          type="text"
          appAmountInput
          formControlName="share"
          class="form-input w-full"
          placeholder="0"
        />

        @if (selectedGuarantor) {
          <p class="mt-1 text-xs text-gray-500">
            {{ 'DISB_NOTE.GUARANTY_CEILING_PKR' | translate }}: {{ selectedGuarantor.grntyCeilngPkr | number: '1.0-2' }}
          </p>
        }

        @if (isInvalid(form.controls.share)) {
          <p class="mt-1 text-xs text-red-600">
            @if (form.controls.share.hasError('required')) {
              {{ 'DISB_NOTE.ERR_SHARE_REQUIRED' | translate }}
            } @else if (form.controls.share.hasError('min')) {
              {{ 'DISB_NOTE.ERR_SHARE_MIN' | translate }}
            } @else if (form.controls.share.hasError('ceilingExceeded')) {
              {{ 'DISB_NOTE.ERR_SHARE_EXCEEDS_CEILING' | translate: { ceiling: (selectedGuarantor?.grntyCeilngPkr | number: '1.0-2') } }}
            }
          </p>
        }
      </div>

      <div>
        <label class="form-label mb-2 block" for="guarantorShareRpymntTrm">
          {{ 'DISB_NOTE.REPAYMENT_TERM' | translate }} <span class="text-red-500">*</span>
        </label>

        <select id="guarantorShareRpymntTrm" formControlName="rpymntTrm" class="form-select w-full">
          <option [ngValue]="null" disabled>{{ 'DISB_NOTE.SELECT_REPAYMENT_TERM' | translate }}</option>
          @for (term of repaymentTerms; track term.value) {
            <option [ngValue]="term.value">{{ term.label }}</option>
          }
        </select>

        @if (isInvalid(form.controls.rpymntTrm)) {
          <p class="mt-1 text-xs text-red-600">{{ 'DISB_NOTE.ERR_REPAYMENT_TERM_REQUIRED' | translate }}</p>
        } @else if (form.hasError('duplicateShare')) {
          <p class="mt-1 text-xs text-red-600">{{ 'DISB_NOTE.ERR_DUPLICATE_GUARANTOR_TERM' | translate }}</p>
        }
      </div>
    </form>
  </app-popup>
}

@if (showDeleteConfirm) {
  <app-popup
    [(show)]="showDeleteConfirm"
    title="DISB_NOTE.DELETE_GUARANTOR_SHARE"
    type="confirm"
    message="DISB_NOTE.DELETE_GUARANTOR_SHARE_CONFIRM"
    confirmText="COMMON.DELETE"
    cancelText="COMMON.CANCEL"
    (confirmed)="confirmDelete()"
  ></app-popup>
}
